import { useMutation } from '@tanstack/react-query';
import { sellerServices } from '../services/seller.service';

export const useUploadFile = () => {
  return useMutation({
    mutationFn: sellerServices.uploadFile,
  });
};